import classNames from 'classnames'
import { map, toSafeInteger } from 'lodash'

import { useMutation } from '@apollo/client'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import styles from './index.module.css'
import MUTATION from './set-authorization.graphql'

const folderPermissionsMap = {
  1: msg`Con permessi di lettura`,
}

const collectionAndContentPermissionsMap = {
  1: msg`Con permessi di lettura`,
  3: msg`Con permessi di gestione`,
}

const LevelButton = ({ id, level, user, __typename }) => {
  const { _ } = useLingui()
  const [mutate] = useMutation(MUTATION, {
    refetchQueries: ['FetchElementAuthorizations'],
  })

  const onChange = ({ target }) => {
    return mutate({
      variables: {
        object: id,
        user,
        value: toSafeInteger(target.value),
      },
    })
  }

  const elementCurrentAuthMap =
    __typename !== 'Folder'
      ? collectionAndContentPermissionsMap
      : folderPermissionsMap

  return (
    <select
      className={classNames(styles.select, 'form-select')}
      defaultValue={level}
      onChange={onChange}
    >
      {map(elementCurrentAuthMap, (name, value: number) => (
        <option key={value} value={value}>
          {_(name)}
        </option>
      ))}
    </select>
  )
}

export default LevelButton
